import { render, staticRenderFns } from "./mail-dashboard.vue?vue&type=template&id=781c5a2e&scoped=true"
import script from "./mail-dashboard.vue?vue&type=script&lang=js"
export * from "./mail-dashboard.vue?vue&type=script&lang=js"
import style0 from "./mail-dashboard.vue?vue&type=style&index=0&id=781c5a2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781c5a2e",
  null
  
)

export default component.exports